export default "__VITE_ASSET__Da817MbV__"